import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import LoadingSpinner from '../components/LoadingSpinner';
import { toast } from 'react-toastify';
import './Services.css';

const API_BASE = process.env.REACT_APP_FILE_API_URL;

const FileList = () => {
  const { user } = useAuth0();
  const username = user?.nickname || user?.name || user?.email;
  const [files, setFiles] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchFiles = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE}/files/user/${username}`, {
        headers: {
          'Authorization': 'Basic YWRtaW46YWRtaW4='
        }
      });
      if (!res.ok) throw new Error('Failed to fetch files');
      setFiles(await res.json());
    } catch (e) {
      setError(`Could not load files: ${e.message}`);
      toast.error('Could not load files. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (username) fetchFiles();
    // eslint-disable-next-line
  }, [username]);

  if (loading) {
    return <div className="loading-overlay"><LoadingSpinner /></div>;
  }

  return (
    <div className="service-page">
      <h1>List Files</h1>
      {loading && <div className="loading-overlay"><LoadingSpinner /></div>}
      {error && <div className="file-error">{error}</div>}
      <div className="file-list">
        {files.length === 0 && <div className="profile-details">No files uploaded yet.</div>}
        {files.map((file) => (
          <div className="file-card" key={file.fileId}>
            <div className="file-info">
              <span className="file-name">{file.fileName}</span>
              <span className="file-size">{file.size ? `${file.size} bytes` : ''}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileList;
